module.exports = __webpack_public_path__ + "static/featuredProductBack-4553c699dcd7a93f6ba19ba1b4280f23.png";